import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import {
  TemplateConfig,
  UnigesLayoutModule,
  UnigesTemplateModule,
} from '@unilog/template';
import { Ng9ListModule } from '@unilog/ng9-list';
import { HomeComponent } from './home/home.component';
import { ActionPrestationComponent } from './action-prestation/action-prestation.component';
import { CalmoisComponent } from './calmois/calmois.component';
import { CollaborateurComponent } from './collaborateur/collaborateur.component';
import { PlanningComponent } from './planning/planning.component';
import { PlanningCollaborateurComponent } from './planning-collaborateur/planning-collaborateur.component';
import { PlanningClientComponent } from './planning-client/planning-client.component';
import { ClientComponent } from './client/client.component';
import { UnilogNg9TableModule } from '@unilog/ng9-table';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeAr);
import { DatePipe } from '@angular/common';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { LOCALE_ID } from '@angular/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ParamCollComponent } from './param-coll/param-coll.component';
import { ParamCompComponent } from './param-comp/param-comp.component';
import { ParamContratComponent } from './param-contrat/param-contrat.component';
import { ParamActionComponent } from './param-action/param-action.component';
import { ParamCompteComponent } from './param-compte/param-compte.component';
import { ParamHeurComponent } from './param-heur/param-heur.component';
import { ParamTauxComponent } from './param-taux/param-taux.component';
import { ListeCollaborateursComponent } from './liste-collaborateurs/liste-collaborateurs.component';
import { ListeClientsComponent } from './liste-clients/liste-clients.component';
import { PlanningActionComponent } from './planning-action/planning-action.component';
import { SuivieCollDialogComponent } from './suivie-coll-dialog/suivie-coll-dialog.component';
import { ShowTreeDocComponent } from './show-tree-doc/show-tree-doc.component';
import { GenerateFactureComponent } from './generate-facture/generate-facture.component';
import { ListeActionDialigComponent } from './liste-action-dialig/liste-action-dialig.component';
import { RessourcesComponent } from './ressources/ressources.component';
import { RechercheComponent } from './recherche/recherche.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { APP_DATE_FORMATS, AppDateAdapter } from './services/AppDateAdapter';
import { AvtInterlocuteurComponent } from './avt-interlocuteur/avt-interlocuteur.component';
import { AvtEchangeComponent } from './avt-echange/avt-echange.component';
import { AvtAlertComponent } from './avt-alert/avt-alert.component';
import { AvtListesComponent } from './avt-listes/avt-listes.component';
import { AvtListeAlertComponent } from './avt-liste-alert/avt-liste-alert.component';
import { AvtListeEchangeComponent } from './avt-liste-echange/avt-liste-echange.component';
// Angular Editor Supprimer
// import { AngularEditorModule } from '@kolkov/angular-editor';
import { AvtEvenementComponent } from './avt-evenement/avt-evenement.component';
import { AvtParamComponent } from './avt-param/avt-param.component';
import { AvtGestDroitUserComponent } from './avt-gest-droit-user/avt-gest-droit-user.component';
import { AvtMatiereCursusComponent } from './avt-matiere-cursus/avt-matiere-cursus.component';
import { AvtActionComponent } from './avt-action/avt-action.component';
import { AvtSalleComponent } from './avt-salle/avt-salle.component';
import { AvtMachineSalleComponent } from './avt-machine-salle/avt-machine-salle.component';
import { AvtListeEvennementComponent } from './avt-liste-evennement/avt-liste-evennement.component';
import { AvtAjouterMatiereCursusComponent } from './avt-ajouter-matiere-cursus/avt-ajouter-matiere-cursus.component';
import { AvtMachineComponent } from './avt-machine/avt-machine.component';
import { AvtListeMachineComponent } from './avt-liste-machine/avt-liste-machine.component';
import { AvtDialogDeleteComponent } from './avt-dialog-delete/avt-dialog-delete.component';
import { AvtListeEvaluationsComponent } from './avt-liste-evaluations/avt-liste-evaluations.component';
import { AvtDocumentComponent } from './avt-document/avt-document.component';
import { AvtListeDocumentComponent } from './avt-liste-document/avt-liste-document.component';
import { AvtRessourcesPedagogiqueComponent } from './avt-ressources-pedagogique/avt-ressources-pedagogique.component';
import { AvtCursusComponent } from './avt-cursus/avt-cursus.component';
import { AvtListeCursusComponent } from './avt-liste-cursus/avt-liste-cursus.component';
import { AvtSuiviePedNoteComponent } from './avt-suivie-ped-note/avt-suivie-ped-note.component';
import { AvtSuiviePedAppreciationComponent } from './avt-suivie-ped-appreciation/avt-suivie-ped-appreciation.component';
import { AvtSuiviePedBulletinNotesComponent } from './avt-suivie-ped-bulletin-notes/avt-suivie-ped-bulletin-notes.component';
import { AvtNoteFraisComponent } from './avt-note-frais/avt-note-frais.component';
import { AvtMachineReservationComponent } from './avt-machine-reservation/avt-machine-reservation.component';
import { AvtListeMachineReservationComponent } from './avt-liste-machine-reservation/avt-liste-machine-reservation.component';
import { AvtMatiereComponent } from './avt-matiere/avt-matiere.component';
import { AvtListeMatiereComponent } from './avt-liste-matiere/avt-liste-matiere.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ActiviterComponent } from './activiter/activiter.component';
import { AvtPlanningComponent } from './avt-planning/avt-planning.component';
import { EditorComponent } from './editor/editor.component';
import { GrhCongeComponent } from './grh/grh-conge/grh-conge.component';
import { GrhFicheComponent } from './grh/grh-fiche/grh-fiche.component';
import { ListeComponent } from './liste/liste.component';
import { HotelReservationComponent } from './hotel/hotel-reservation/hotel-reservation.component';
import { TarifReservationComponent } from './hotel/tarif-reservation/tarif-reservation.component';
import { ListeReservationComponent } from './hotel/liste-reservation/liste-reservation.component';
import { ImpressionComponent } from './hotel/impression/impression.component';
import { GrhAccidentComponent } from './grh/grh-accident/grh-accident.component';
import { PrintComponent } from './print/print.component';
import { CasteloPresentationComponent } from './castelo/castelo-presentation/castelo-presentation.component';
import { QuestionnaireComponent } from './mme-rekik/questionnaire/questionnaire.component';
import { SharedModule } from './shared/shared.module';
//-------------------------------------- caisse --------------------------------------
import { OpenCaisseComponent } from './caisse/open-caisse/open-caisse.component';
import { CloseCaisseComponent } from './caisse/close-caisse/close-caisse.component';
import { StateCaisseComponent } from './caisse/state-caisse/state-caisse.component';
import { TicketListComponent } from './caisse/ticket-list/ticket-list.component';
import { ListFideliteComponent } from './caisse/list-fidelite/list-fidelite.component';
import { ClientDialogComponent } from './caisse/client-dialog/client-dialog.component';
import { CaisseComponent } from './caisse/caisse/caisse.component';
//-------------------------------------- fin caisse --------------------------------------

//--------------------------------- module de traduction---------------------------------
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
//--------------------------------- module de traduction---------------------------------

import { ScrollingModule } from '@angular/cdk/scrolling';
import { SimedModule } from './simed/simed.module';
import { SuiviCodeBarreComponent } from './caisse/suivi-code-barre/suivi-code-barre.component';
import { DashboardSuiviComponent } from './caisse/dashboard-suivi/dashboard-suivi.component';
import { UnigesInputModule } from '@unilog/input';
import { RapportVisiteComponent } from './rapport-visite/rapport-visite.component';
import { FicheClientComponent } from './CRM/fiche-client/fiche-client.component';
import { ReclamationComponent } from './CRM/reclamation/reclamation.component';
import { StockComponent } from './CRM/stock/stock.component';
import { AjouterHierarchieComponent } from './Hierarchie/ajouter-hierarchie/ajouter-hierarchie.component';
import {
  DiagramModule,
  HierarchicalTreeService,
  DataBindingService,
} from '@syncfusion/ej2-angular-diagrams';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { HierarchieModifModalComponent } from './Hierarchie/hierarchie-modif-modal/hierarchie-modif-modal.component';
import { SideBarInfoComponent } from './Hierarchie/side-bar-info/side-bar-info.component';
import { TableRModule } from './table-r/table-r.module';
import { ColisCardComponent } from './caisse/dashboard-suivi/colis-card/colis-card.component';
import { MeteoComponent } from './caisse/meteo/meteo.component';
import { SuiviProductionComponent } from './suivi-production/suivi-production.component';
import { ShopfloorOverviewComponent } from './shopfloor-overview/shopfloor-overview.component';
import { NouveauxEmployesComponent } from './grh/nouveaux-employes/nouveaux-employes.component';
import { CommandComponent } from './CRM/command/command.component';
import { DevisComponent } from './CRM/devis/devis.component';
import { RecapExportComponent } from './recap-export/recap-export.component';
import { RecapAnalyseComponent } from './recap-analyse/recap-analyse.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import { RecommandationsComponent } from './CRM/recommandations/recommandations.component';
import { AddRapportVisiteComponent } from './CRM/add-rapport-visite/add-rapport-visite.component';
import { RapportVisiteConsultComponent } from './CRM/rapport-visite-consult/rapport-visite-consult.component';
import { TreeTableComponent } from './tree-table/tree-table.component';
import { TableauStatistiqueComponent } from './caisse/tableau-statistique/tableau-statistique.component';
import { DevToolsComponent } from './dev-tools/dev-tools.component';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { BureauEtudeComponent } from './bureau-etude/bureau-etude.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { RechuteComponent } from './grh/rechute/rechute.component';
import { RapportStatComponent } from './grh/rapport-stat/rapport-stat.component';
import { MaladiProfComponent } from './grh/maladi-prof/maladi-prof.component';
import { PlanningCrmComponent } from './CRM/planning-crm/planning-crm.component';
import { EcartComponent } from './qualite/ecart/ecart.component';
import { ReunionComponent } from './qualite/reunion/reunion.component';
import { ConsultMaladieProComponent } from './grh/consult-maladie-pro/consult-maladie-pro.component';
import { ConsultAccidentComponent } from './grh/consult-accident/consult-accident.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { FournisseurComponent } from './hotel/fournisseur/fournisseur.component';
import { BraquetComponent } from './hotel/braquet/braquet.component';
import { MenuRestaurantComponent } from './hotel/menu-restaurant/menu-restaurant.component';
import { DatePickerModule } from '@unilog/date-picker';

const themeConfig: TemplateConfig = {
  url: environment.apiEndPoint,
  hubUrl: environment.hubEndPoint, //pour service notofication,mail...
  logo: {
    path: '/assets/logo_centre.png',
    height: '47px',
    width: 'none',
  },
  logo2: {
    path: '/assets/logo_centre.png',
    height: '32px',
    width: 'none',
  },
  ringFile: '/assets/phoneRing.wav', // sonnerie téléphone
  sideNavPath: 'avt',
  defaultRoute: 'home', // route de composon par default (page index)
  application: 'avt',
  theme: {
    backgroundColor: '#3f51b5',
    color: '#FFF',
  },
  menuItems: [],

  menu: {
    url: environment.apiEndPoint,
  },
  chat: {
    enable: false,
  },
  notification: {
    enable: false,
  },
  email: {
    enable: false,
  },
};

@NgModule({
  declarations: [
    ConsultAccidentComponent,
    OpenCaisseComponent,
    CloseCaisseComponent,
    StockComponent,
    StateCaisseComponent,
    TicketListComponent,
    ListFideliteComponent,
    ClientDialogComponent,
    CaisseComponent,
    QuestionnaireComponent,
    CasteloPresentationComponent,
    GrhAccidentComponent,
    HotelReservationComponent,
    ListeReservationComponent,
    TarifReservationComponent,
    ImpressionComponent,
    GrhFicheComponent,
    GrhCongeComponent,
    NouveauxEmployesComponent,
    ConsultMaladieProComponent,
    AppComponent,
    HomeComponent,
    ShowTreeDocComponent,
    ListeActionDialigComponent,
    CalmoisComponent,
    AvtDialogDeleteComponent,
    AvtInterlocuteurComponent,

    ListeClientsComponent,
    ListeCollaborateursComponent,
    AvtListesComponent,
    RechercheComponent,
    ActionPrestationComponent,
    AvtAjouterMatiereCursusComponent,
    ActionPrestationComponent,
    CalmoisComponent,
    CollaborateurComponent,
    PlanningComponent,
    PlanningCollaborateurComponent,
    PlanningClientComponent,
    ParamCollComponent,
    ParamCompComponent,
    ParamContratComponent,
    ParamActionComponent,
    ParamCompteComponent,
    ParamHeurComponent,
    ParamTauxComponent,
    ListeCollaborateursComponent,
    ListeClientsComponent,
    PlanningActionComponent,
    MaladiProfComponent,
    SuivieCollDialogComponent,
    ShowTreeDocComponent,
    GenerateFactureComponent,
    ListeActionDialigComponent,
    RessourcesComponent,
    RechercheComponent,
    AvtInterlocuteurComponent,
    AvtEchangeComponent,
    AvtAlertComponent,
    AvtListesComponent,
    AvtListeAlertComponent,
    AvtListeEchangeComponent,
    AvtEvenementComponent,
    AvtParamComponent,
    AvtGestDroitUserComponent,
    AvtMatiereCursusComponent,
    AvtAjouterMatiereCursusComponent,
    AvtActionComponent,
    AvtSalleComponent,
    AvtMachineSalleComponent,
    AvtListeEvennementComponent,
    AvtMachineComponent,
    AvtListeMachineComponent,
    AvtDialogDeleteComponent,
    AvtListeEvaluationsComponent,
    AvtDocumentComponent,
    AvtListeDocumentComponent,
    AvtRessourcesPedagogiqueComponent,
    AvtCursusComponent,
    AvtListeCursusComponent,
    AvtSuiviePedNoteComponent,
    AvtSuiviePedAppreciationComponent,
    AvtSuiviePedBulletinNotesComponent,
    AvtNoteFraisComponent,
    AvtMachineReservationComponent,
    AvtListeMachineReservationComponent,
    AvtMatiereComponent,
    AvtListeMatiereComponent,
    CalendarComponent,
    ActiviterComponent,
    AvtPlanningComponent,
    EditorComponent,
    ClientComponent,
    ListeComponent,
    PrintComponent,
    SuiviCodeBarreComponent,
    DashboardSuiviComponent,
    RapportVisiteComponent,
    FicheClientComponent,
    RechuteComponent,
    RapportStatComponent,
    ReclamationComponent,
    AjouterHierarchieComponent,
    HierarchieModifModalComponent,
    SideBarInfoComponent,
    ColisCardComponent,
    MeteoComponent,
    SuiviProductionComponent,
    ShopfloorOverviewComponent,
    CommandComponent,
    DevisComponent,
    RecapExportComponent,
    RecapAnalyseComponent,
    RecommandationsComponent,
    AddRapportVisiteComponent,
    RapportVisiteConsultComponent,
    TreeTableComponent,
    TableauStatistiqueComponent,
    DevToolsComponent,
    BureauEtudeComponent,
    TimePickerComponent,
    PlanningCrmComponent,
    EcartComponent,
    ReunionComponent,
    ConfirmComponent,
    FournisseurComponent,
    BraquetComponent,
    MenuRestaurantComponent,
  ],
  imports: [
    SimedModule,
    MonacoEditorModule.forRoot(),
    MatTableExporterModule,
    SharedModule,
    ScrollingModule,
    UnigesInputModule,
    ToolbarModule,
    UnigesLayoutModule.forRoot(themeConfig.url),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    UnigesTemplateModule.forRoot(themeConfig),
    AppRoutingModule,
    GooglePlaceModule,
    Ng9ListModule,
    UnilogNg9TableModule,
    NgApexchartsModule,
    DiagramModule,
    DatePickerModule,

    TableRModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      outerStrokeWidth: 15,
      showUnits: true,
      showBackground: false,
      animationDuration: 300,
      backgroundGradient: true,
      lazy: false,
      showSubtitle: false,
      outerStrokeGradient: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
    HierarchicalTreeService,
    DataBindingService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    CollaborateurComponent,
    ListeActionDialigComponent,
    AvtInterlocuteurComponent, /////////22/10/2019
    AvtAlertComponent, /////////22/10/2019
    AvtEchangeComponent, /////////22/10/2019
    AvtAjouterMatiereCursusComponent, /////////10/12/2019
    AvtMachineSalleComponent, /////17/12/2019
    AvtDialogDeleteComponent, /////25/02/2020
    AvtSuiviePedNoteComponent, /////07/05/2020
    AvtSuiviePedBulletinNotesComponent, //////////12/05/2020
  ],
  exports: [
    Ng9ListModule,
    ScrollingModule,
    UnigesTemplateModule,
    AvtListesComponent,
    ShowTreeDocComponent,
    RechercheComponent,
    EditorComponent,
    ListeComponent,
    TreeTableComponent,
  ],
})
export class AppModule {}
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
